import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "webinar_card_icon_reaction_heart",
  "use": "webinar_card_icon_reaction_heart-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"webinar_card_icon_reaction_heart\"><path d=\"M31.898 10.518a8.771 8.771 0 0 0-8.771-8.771A8.755 8.755 0 0 0 16 5.417a8.754 8.754 0 0 0-7.126-3.67 8.77 8.77 0 0 0-8.772 8.771c0 .686.087 1.351.236 1.992C1.556 20.077 9.97 28.06 16 30.252c6.03-2.191 14.443-10.175 15.66-17.74.15-.642.238-1.307.238-1.994Z\" fill=\"#DD2E44\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol